if (typeof RecentProductsCache === 'undefined') {
  class RecentProductsCache {
    constructor() {
      this.limit = 10;
      this.currentList = this.getCurrentListFromStorage();
    }

    // MODI 2026-09-26: the key is versioned — every cached card from before this date carries
    // a live /cart/add form snapshot that knows nothing of the reserve rule; v2 cards are
    // rendered link-only (snippets/product.liquid → card-product no_quick_add), so a product
    // that later goes out of stock can never be added from a stale snapshot.
    getCurrentListFromStorage() {
      const raw = localStorage.getItem(`theme:recently-viewed:v2`);
      return JSON.parse(raw) || [];
    }

    addProductsToStorage(container = document) {
      const elements = container.querySelectorAll('[data-recent-product-handle]');
      elements.forEach((el) => {
        const handle = el.dataset.recentProductHandle;
        const data = {
          handle,
          element: el.innerHTML,
        };
        const position = this.currentList.findIndex((item) => item.handle === handle);
        if (position === -1) {
          this.currentList = [data, ...this.currentList].slice(0, this.limit);
        } else {
          this.currentList = [data, ...this.currentList.filter((_, i) => i !== position)];
        }
      });
      localStorage.setItem('theme:recently-viewed:v2', JSON.stringify(this.currentList));
    }
  }

  window.recentProductsCache = new RecentProductsCache();
  window.recentProductsCache.addProductsToStorage();
}
